import { cn } from '@/lib/utils'

type Props = {
  statusCode?: number
}

const getStatusCodeColor = (statusCode: number): string => {
  if (statusCode >= 500) {
    return 'bg-destructive'
  }
  if (statusCode >= 400) {
    return 'bg-amber-500'
  }
  if (statusCode >= 300) {
    return 'bg-slate-500'
  }
  if (statusCode >= 200) {
    return 'bg-sky-500'
  }
  return 'bg-slate-500'
}

export const StatusCodeIndicator = ({ statusCode }: Props) => {
  if (!statusCode) {
    return <span className="w-1 h-5 shrink-0" />
  }

  return (
    <span
      className={cn(
        'w-1 h-5 shrink-0 rounded-full',
        getStatusCodeColor(statusCode)
      )}
      title={String(statusCode)}
    />
  )
}
